// extracted by mini-css-extract-plugin
export default {"headlineSeparator":"JdYNtBjSSS0HoiyFaJW3","fadeIn":"EsT1jFYJt2gnhppVgk4Z"};